import React, { useState } from "react";
import { useMediaQuery } from 'react-responsive';
import { Link } from 'react-router-dom';
// ============================================
// LOGIN FUNCTIONALITY COMMENTED OUT
// ============================================
// import { useAuth } from '../context/AuthContext';
import config from '../config/environment';
import { toLowerCasePath } from '../extensions/utilityExtensions';
// import ProfileImage from './common/ProfileImage';

import Logo from "./logo";
import SearchPageComponent from './searchPageComponent';
import BurgerMenu from "./burgerMenu";

import "./styles/containers.css"
import "./styles/header.css"
import "./styles/text.css"

const API_URL = config.API_URL;
const APP_URL = config.APP_URL;

function HeaderRelative() {
    const isMobileLarge = useMediaQuery({ query: '(height > 1616px)' });
    const isMobileWidth = useMediaQuery({ maxWidth: 1024 });
    const [backgroundStyle, setBackgroundStyle] = useState({ left: 0, width: 0, opacity: 0 });
    // ============================================
    // LOGIN FUNCTIONALITY COMMENTED OUT
    // ============================================
    // const { user, isAuthenticated } = useAuth();

    const handleLinkHover = (e) => {
        const rect = e.target.getBoundingClientRect();
        setBackgroundStyle({
            left: rect.left - e.target.parentElement.getBoundingClientRect().left,
            width: rect.width,
            opacity: 1
        });
    };

    const handleLinksMouseLeave = () => {
        setBackgroundStyle(prev => ({ ...prev, opacity: 0 }));
    };

    return (
        <header className="headerRelative">
            <nav className="nav-content">
                <div className="nav-left">
                    <Link to={toLowerCasePath("/")} className="nav-logo-container">
                        <Logo />
                        <h2 className={`nav-logo-text ${isMobileLarge ? "fontSize40px" : "fontSize25px"}`}>
                            Razul Artworks
                        </h2>
                    </Link>
                </div>
                <div className="nav-right">
                    <SearchPageComponent />
                    {(isMobileLarge || isMobileWidth) ? (
                        <BurgerMenu />
                    ) : (
                        <div className="nav-links" onMouseLeave={handleLinksMouseLeave}>
                            <div className="nav-background" style={backgroundStyle} />
                            <Link to={toLowerCasePath("/library")} className="nav-link" onMouseEnter={handleLinkHover}>Library</Link>
                            <Link to={toLowerCasePath("/about")} className="nav-link" onMouseEnter={handleLinkHover}>About</Link>
                            <Link to={toLowerCasePath("/contact-us")} className="nav-link" onMouseEnter={handleLinkHover}>Contact</Link>

                            {/* ============================================ */}
                            {/* LOGIN FUNCTIONALITY COMMENTED OUT */}
                            {/* ============================================ */}
                            {/* {isAuthenticated() ? (
                                <Link to="/profile" className="nav-profile-link" onMouseEnter={handleLinkHover}>
                                    <div className="nav-user-avatar" style={{ 
                                        width: isMobileLarge ? '48px' : '32px', 
                                        height: isMobileLarge ? '48px' : '32px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        overflow: 'visible',
                                        position: 'relative',
                                    }}>
                                        <ProfileImage size={isMobileLarge ? 48 : 32} />
                                    </div>
                                </Link>
                            ) : (
                                <Link to="/login" className="nav-link" onMouseEnter={handleLinkHover}>Login</Link>
                            )} */}
                        </div>
                    )}
                </div>
            </nav>
        </header>
    );
}

export default HeaderRelative;